/**
 * La leyenda de un gráfico. Nunca opcional con dos o más series.
 *
 * El color no puede ser el único canal que dice qué es cada cosa: quien no
 * distingue el naranja del verde tiene que poder leer el gráfico igual, y una
 * impresión en escala de grises también. La marca de color va AL LADO del
 * rótulo, y el rótulo va en tinta de texto — nunca en el color de su serie, que
 * es el error que convierte una leyenda en cuatro palabras ilegibles.
 */

export interface Serie {
  id: string;
  label: string;
  /** 1, 2 o 3. El color sigue a la ENTIDAD, no a su posición en un filtro. */
  slot: 1 | 2 | 3;
}

export function Leyenda({ series }: { series: Serie[] }) {
  if (series.length < 2) return null; // con una serie, el título ya la nombra
  return (
    <ul className="viz-leyenda">
      {series.map((s) => (
        <li key={s.id}>
          <span className={`viz-marca serie-${s.slot}`} aria-hidden="true" />
          {s.label}
        </li>
      ))}
    </ul>
  );
}
